import {DocumentEditor} from '@syncfusion/ej2-documenteditor';
import {Observable} from 'rxjs';
import {fromPromise} from 'rxjs/internal-compatibility';
import {concatMap} from 'rxjs/operators';
import {EncodeDecode} from './encode-decode';

export type base64string = string;

export class FileConversionsUtil {
  static exportDocxContentAsBase64(documentEditor: DocumentEditor): Observable<base64string> {
    return fromPromise<Blob>(documentEditor.saveAsBlob('Docx')).pipe(
      concatMap(contentBlob => this.fileBlobToBase64(contentBlob)),
    );
  }

  static exportSfdtContentAsBase64(documentEditor: DocumentEditor): Observable<base64string> {
    return fromPromise<Blob>(documentEditor.saveAsBlob('Sfdt')).pipe(
      concatMap(contentBlob => this.blobToBase64(contentBlob)),
    );
  }

  static exportFileAsStringContent(file: File): Observable<string> {
    return this.fileToStringContent(file);
  }

  static blobToBase64(blob: Blob): Observable<base64string> {
    const reader = new FileReader();
    reader.readAsText(blob);
    return new Observable(subscriber => {
      reader.onloadend = () => {
        subscriber.next(EncodeDecode.b64EncodeUnicode(reader.result));
        subscriber.complete();
      };
    });
  }

  static imageBlobToBase64(blob: Blob): Observable<base64string> {
    return new Observable(subscriber => {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        subscriber.next(reader.result as string)
        subscriber.complete()
      })
      reader.readAsDataURL(blob);
    })
  }

  static fileBlobToBase64(blob: Blob): Observable<base64string> {
    const reader = new FileReader();
    return new Observable(subscriber => {
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        subscriber.next((reader.result as base64string).split(',')[1]);
        subscriber.complete();
      };
    });
  }

  static fileToStringContent(file: File): Observable<string> {
    const reader = new FileReader();
    return new Observable(subscriber => {
      reader.onloadend = () => {
        subscriber.next(reader.result as string);
        subscriber.complete();
      };
      reader.readAsText(file);
    });
  }
}
